/*
 * @Author: 王琪瑞
 * @Date: 2021-03-18 17:11:16
 * @LastEditTime: 2021-03-23 14:41:20
 * @LastEditors: 王琪瑞
 */
import {
  PageI, QueryI,
} from '@/interface/basicOperations';
import axios from '@/axios/api';
import { definitions } from '@/types/api';
import { reactive, onMounted } from 'vue';

export interface CustomCaseI extends QueryI<unknown, definitions['CustomCase'][]> {
  totalRecords: number;

  /**
   * 案例列表
   */
  list: definitions['CustomCase'][];
}

export class CustomCase implements CustomCaseI {
  totalRecords = 0;

  list: definitions['CustomCase'][] = [];

  // eslint-disable-next-line class-methods-use-this
  async query(reqData: PageI): Promise<definitions['CustomCase'][]> {
    try {
      const { data } = (await axios.queryAllCustomCase(reqData.pageSize, reqData.pageNo)).data;
      this.list = data.list || [];
      this.totalRecords = data.totalRecords || 0;
      return this.list;
    } catch (err) {
      throw new Error(err);
    }
  }
}

export default () => {
  const pagination = reactive({
    pageSize: 6,
    pageNo: 1,
  });

  // 案例列表数据
  const customCaseModule = reactive(new CustomCase());

  const handlePageChange = async () => {
    try {
      await customCaseModule.query(pagination);
    } catch (err) {
      throw new Error(err);
    }
  };

  onMounted(async () => {
    await customCaseModule.query(pagination);
  });

  return {
    pagination,
    customCaseModule,
    handlePageChange,
  };
};
